























# Lib autocomplete https://github.com/paliari/v-autocomplete
listItem = require './filter_tag_item.vue'
helpers = require '../../../helpers.coffee'
on_clickaway = require('vue-clickaway')

view_model = {
  mixins: [ on_clickaway.mixin ]

  props:
    filter_item_selected_ids:
      default: -> []

    uncheck_all_items:
      default: false

  data : ->
    current_company: Session.current_company
    current_user: Session.current_user
    tag: null
    tags: []
    tags_all: []
    template: listItem
    show_tags: true
    selected_tag_ids: []
    attrs: {
      placeholder: @$t('contacts.label.searchTags')
    }

  watch:
    tags:
      handler: (tags)->
        for tag in tags
          tag_all = @tags_all.find (t)-> tag.id == t.id
          tag_all.behavior = tag.behavior

        selected_items = (@tags_all.filter (t)-> t.behavior == 'check')
        current_selected_ids = selected_items.map (t)-> t.id
        data = { selected_items: selected_items }

        if @selected_tag_ids.length != current_selected_ids.length
          @selected_tag_ids = current_selected_ids
          @$emit 'item-selected-items', data

      deep: true

    uncheck_all_items:
      handler: ->
        tag.behavior = 'uncheck' for tag in @tags

  methods:
    getLabel: (item) ->
      item.name

    setFocus: ->
      jQuery('#'+@id+'.v-autocomplete .v-autocomplete-input').focus()

    tagIndex: ->
      new TagsResource().index(@loadTagsSuccess, null, params: { q: { company_id_eq: @current_company.id } })

    loadTagsSuccess: (data) ->
      @tags_all = []
      @tags = []

      for tag in data.tags
        checked = (@filter_item_selected_ids || []).indexOf("#{tag.id}") >= 0
        tag.behavior = if checked then 'check' else 'uncheck'

        @tags_all.push(tag)
        @tags.push(tag)

    itemClicked: (item) ->
      item.behavior = if item.behavior == 'check' then 'uncheck' else 'check'
      @tag = null

    clearInput: ->
      @$refs.tag_autocomplete.searchText = ''
      @$refs.tag_autocomplete.inputChange()

    filterTags: (text) ->
      return(@tags = @tags_all) if text == ''

      @tags = []
      regex = new RegExp(text, 'i')
      for tag in @tags_all when regex.exec(tag.name)
        @tags.push(tag)

  created: ->
    @tagIndex()
    @id = 'dropdown-filter-tags'
    @contact_resource = new ContactsResource Session.current_company.id
    @setFocus()
}
exports.default = helpers.vue_include(view_model, helpers.form)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/autocomplete/filter_tags.vue